import { LitComponent } from "./lit-component";

import type { ProductFormOption } from "src/utils/ProductUtil";
import type { PropertyDeclarations, PropertyValueMap } from "lit";

export class OptionSelect extends LitComponent {
  static properties: PropertyDeclarations = {
    icon: { type: String },
    option: { type: Object },
    defaultText: { type: String },
    disableSoldoutValues: { type: Boolean },
    hideUnavailableValues: { type: Boolean },
  };

  option?: ProductFormOption;
  icon = "caret";
  defaultText?: string;
  disableSoldoutValues?: boolean;
  hideUnavailableValues?: boolean;

  get app() {
    if (!window.WishlistKing) {
      throw new Error("Wishlist King SDK not initialized");
    }

    return window.WishlistKing;
  }

  render() {
    if (!this.option) {
      return;
    }

    const option = this.option;
    const name = `options[${option.name}]`;
    const inputId = `${this.app.utils.url.handlelize(this.id)}-select`;

    const values = option.values.filter(
      (value) =>
        !this.hideUnavailableValues ||
        !option.unavailableValues.includes(value),
    );

    const selectedValueUnavailable =
      option.selectedValue &&
      option.unavailableValues.includes(option.selectedValue);

    return this.lit.html`
      <div class="wk-option-select">
        <label class="wk-label" for=${inputId}>${option.name}</label>
        <div class="wk-control">
          <select id=${inputId} class="wk-input" name=${name}>
            ${
              (!option.selectedValue ||
                (this.hideUnavailableValues && selectedValueUnavailable)) &&
              this.lit.html`<option disabled selected>${
                this.defaultText ?? "Select"
              }</option>`
            }
            ${values.map(
              (value) => this.lit.html`
                <option
                  value=${value}
                  ?selected=${value === option.selectedValue}
                  ?disabled=${
                    this.disableSoldoutValues &&
                    option.soldoutValues.includes(value)
                  }
                >
                  ${value}
                </option>
              `,
            )}
          </select>
          <div class="wk-content">
            <div class="wk-text">
              ${option.selectedValue || this.defaultText}
            </div>
            <wk-icon class="wk-icon" icon=${this.icon}></wk-icon>
          </div>
        </div>
      </div>
    `;
  }

  protected updated(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    super.updated(_changedProperties);

    if (_changedProperties.has("option")) {
      this.classList.toggle(
        "wk-single-option",
        this.option?.values.length === 1,
      );
    }
  }

  createRenderRoot() {
    return this;
  }
}

if (!customElements.get("wk-option-select")) {
  customElements.define("wk-option-select", OptionSelect);
}

declare global {
  interface HTMLElementTagNameMap {
    "wk-option-select": OptionSelect;
  }
}
